import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
  effect,
  ElementRef,
  inject,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'app-textarea',
  imports: [FormsModule],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor {
  readonly label = input<string>('');
  readonly placeholder = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly error = input<string | boolean>(false);
  readonly errorType = input<'text-bottom' | 'outline'>('text-bottom');
  readonly value = model<string>('');
  readonly id = input.required<string>();
  readonly rows = input<number>(3);
  readonly submitting = input<boolean>(false);

  private elementRef = inject(ElementRef);
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {
    effect(() => {
      const currentValue = this.value();
      if (currentValue !== undefined) {
        this.onChange(currentValue);
      }
    });
  }

  writeValue(value: string): void {
    if (value !== undefined) {
      this.value.set(value);
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onKeyDown(event: KeyboardEvent): void {
    // Submit form when Ctrl+Enter is pressed
    if (event.key === 'Enter' && event.ctrlKey) {
      const form = this.elementRef.nativeElement.closest('form');
      if (form) {
        event.preventDefault();
        form.dispatchEvent(new Event('submit'));
      }
    }
  }
}
